import React from 'react';
import Style from './style.sass';

const DatePicker = props => {
  // 当年
  const currentYear = props.year;
  // 当月
  const currentMonth = props.month;
  // 当月１日の日付
  const firstDate = new Date(currentYear, currentMonth -1, 1);
  // 翌月の０日を指定して当月の末日の日付を取得
  const lastDate = new Date(currentYear, currentMonth, 0);
  // 当月の日数
  const NumberOfDays = lastDate.getDate();
  // 当月初日の曜日
  const firstDay = firstDate.getDay();
  // 曜日
  const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
  // 現在日時
  const current = new Date();
  // 本日0時
  const today = current.setHours(0, 0, 0, 0);
  // 日付データを格納する用の配列
  const weeks = [[]];
  // 週数
  let weekNumber = 0;

  // 前月の最終週を日付が新しい順に生成
  for (let i = 0; i < firstDay; i++) {
    weeks[0].unshift(new Date(currentYear, currentMonth - 1, - i));
  }

  // 当月１日から末日をループ
  for (let i = 1; i <= NumberOfDays; i++) {
    if(weeks[weekNumber].length === 7){
      weeks.push([]);
      weekNumber++
    }
    weeks[weekNumber].push(new Date(currentYear, currentMonth -1, i));
  }

  // 翌月の１周目を生成
  for (let i = 1; weeks[weekNumber].length < 7; i++) {
    weeks[weekNumber].push(new Date(currentYear, currentMonth, i));
  }

  const showWeeks = weeks.map((week, i) => {
    return (
      <tr key={i}>
        {week.map((day, n) => {
          return (
            <td key={n} data-year={day.getFullYear()} data-month={day.getMonth() + 1} data-date={day.getDate()} data-weekday={n} data-today={day.setHours(0,0,0,0) === today} data-anothermonth={day.getMonth() + 1 != currentMonth} onClick={ e => props.hundleClickDate(e)}>{day.getDate()}</td>
          )
        }
        )}
      </tr>
    )
  })

  return (
    <table className={Style.Calendar__table}>
      <thead>
        <tr>{weekdays.map((weekday, i) => <th key={i}>{ weekday }</th>)}</tr>
      </thead>
      <tbody>
        { showWeeks }
      </tbody>
    </table>
  )
}

export default DatePicker;